let UserListInfo = {
    filter: ["전체", "현재 수강생", "레슨 전날 대상자", "재등록 일주일 전", "생일자 정리", "시작일 미정자", "수강 6개월 이상"],
    label: ["번호", "지점", "이름", "생년월일", "휴대폰 번호", "비고"],
    detailLabel: ["수강 지점", "이름", "성별", "생년월일", "연락처", "주소", "로그인 아이디", "이메일", "피아노 경력", "희망장르", "방문경로", "문자수신 여부",
        "잔여 레슨 수", "사용 레슨 수", "담당 선생님", "등록기간", "", "결제 횟수", "최초 등록일"],
    detailDataName: ["location", "name", "gender", "birth", "contact", "address", "loginid", "email", "ability", "genre", "howto", "subscribed",
        "lesson_count", "lesson_count_used", "teacher_in_charge", "register_start_date", "register_end_date", "payment_count", "registration"],
    detailDataFormating: ["", "", "", "", "", "", "", "", "", "", "", "",
        "회", "회", "", "", "", "회", ""],
    detailEditRegex: ["", ".+", "", "[0-9]{4}-[0-9]{1,2}-[0-9]{1,2}", "[0-9]+", ".+", "\\w+", "[\\w.]+@[\\w]+\\.[\\w]+", "", "", "", "",
        "[0-9]+", "[0-9]+"],
    InvalidMessage: ["선택되지 않았습니다.", "입력되지 않았습니다.", "선택되지 않았습니다.", "날짜 형식이 아닙니다.", "하이픈(-) 제외 숫자만 입력하세요.", "입력되지 않았습니다.", "영어, 숫자만 가능합니다.", "잘못된 이메일 형식입니다.", "", "", "선택되지 않았습니다.",
        "숫자만 입력하세요.", "숫자만 입력하세요.", "날짜 형식이 아닙니다.", "날짜 형식이 아닙니다."],
    notEditableDetailIndexStart: 14,
    registerLastIndex: 10,
    buttonName: ["상세 보기", "레슨 내역", "결제 내역"],
}

export default UserListInfo;